/* eslint-disable */
/* @flow */

import React, { Component } from 'react'
import { Image, Text, TouchableOpacity, View, Platform } from 'react-native'
import LinearGradient from 'react-native-linear-gradient'

import {Images} from '../Themes'

import styles from './Styles/NavigationBarStyle'
import { Fonts} from   '../Themes'


class NavigationBar extends Component{
  constructor(props) {
    super(props);
    this.state = {
      leftButtons: [],
      rightButtons: [],
    }
  }
 

  setLeftNavBarButtons = (buttons) => {
    this.setState({ leftButtons: buttons })
  }

  setRightNavBarButtons = (buttons) => {
    this.setState({ rightButtons: buttons })
  }

  renderButton = (button, key) => {
   
    console.info("rendering nav button " + button.type + " key = " + key )

    const dis = button.onPress ? false : true

    // back icon is not rendering on web (SVG?) so we use text for now
    const isWeb = (Platform.OS == 'web')

    return (
      <TouchableOpacity
        disabled={/*!button.onPress*/dis}
        key={key}
        onPress={button.onPress}
        style={styles.button}>
        {button.type === 'back' && <Image source={Images.backNav} />}
        {button.type === 'close' && <Image source={Images.crossNav} />}
        {button.type === 'profile' && <Image source={Images.profiles} />}
        {button.type === 'settings' && (<Image source={Images.settings} />)}
        {button.type === 'hamburger' && (
          <Image source={Images.menuIcon} />
        )}
        {button.type === 'title' && (
          <Text style={styles.buttonTitle}>{button.title}</Text>
        )}
        {isWeb && <Text style={{color: 'white', fontFamily: Fonts.style.font.bold}}>{button.type}</Text>}
      </TouchableOpacity>
    )
  }

  renderTitle = () => {
    const {  title ,type} = this.props
   

    if (title) {
      return <Text style={type == 'white' ? styles.titleBlack : styles.titleWhite}>{title}</Text>
    }

    return <Image source={Images.kargoeNav} style={styles.logo} />
  }

  renderContent = () => {
    
    const { leftButtons, rightButtons } = this.state

    

    return (
      <View>
        <View style={styles.statusBar} />
        <View style={styles.content}>
          <View style={styles.leftButtons}>
            {leftButtons &&
              leftButtons.map((button, i) => this.renderButton(button, i))}
          </View>
          {this.renderTitle()}
          <View style={styles.rightButtons}>
            {rightButtons &&
              rightButtons.map((button, i) => this.renderButton(button, i))}
          </View>
        </View>
      </View>
    )
  }

  
  render() {
    const { type } = this.props
   

    if (type === 'white') {
      return (
        <View
          style={[
            styles.container,
            styles.navbar,
          ]}>
          {this.renderContent()}
        </View>
      )
    }

    else if (type === 'black') {
      return (
        <View
          style={[
            styles.container,
            styles.navbar,
            {backgroundColor : 'black'}
          ]}>
          {this.renderContent()}
        </View>
      )
    }

    return (
      <LinearGradient
        colors={Fonts.style.color.gradient}
        style={styles.container}>
        {this.renderContent()}
      </LinearGradient>
    )
  }
}

export default NavigationBar
